const base = 1000;

const primevueDefaults = {
  menu: base,
  modal: base + 100,
  overlay: base,
  tooltip: base + 100,
};

const apxExtensions = {
  confirm: primevueDefaults.overlay,
  dialog: primevueDefaults.modal,
  drawer: primevueDefaults.modal,
  mask: primevueDefaults.overlay - 1,
  toast: primevueDefaults.modal,
};

export type PrimevueElevationCategory = keyof typeof primevueDefaults;

export const Elevation = Object.freeze({
  ...primevueDefaults,
  ...apxExtensions,
} as const);

export type ElevationCategory = Exclude<keyof typeof Elevation, 'mask'>;
